module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/b1d3c5c7ec3cdf034e684bd2ab0b96c4.png";